import { SET_DEVICE_ID } from 'root/src/client/logic/app/actionIds'
import { appStoreLenses } from 'root/src/client/logic/app/lenses'

const { setDeviceId } = appStoreLenses

export default {
	[SET_DEVICE_ID]: (state, deviceId) => setDeviceId(deviceId, state),
}
